import { Button, FormGroup, Input, Label, Select } from '@/components'
import { FlexWrapper } from '@/components/layout/flex/flexWrapper'
import { useAxios } from '@/context/axiosContext'
import { useEffect, useRef, useState } from 'react'
import DataTable, { TableColumn } from 'react-data-table-component'
import { useLocation, useNavigate } from 'react-router-dom'
import commonUtils from '@/utils/commonUtils'
import { useRedis } from '@/hooks/useRedis'
import { useLog } from '@/hooks/useLog'

type TInput = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement

interface DataRow {
  cmpnyCd: string
  nttSn: string
  regId: string
  regDate: string
  updId: string
  updDate: string
  cstId: string
  bbsSj: string
  prmtType: string
  prmtTypeNm: string
  nttSj: string
  nttCn: string
  prmtStartDate: string
  prmtEndDate: string
  prmtUrl: string
  // thumbnailSeq: string
  readngCnt: string
  adminDelYn: string
  adminDelYnNm: string
  tpPrmtYn: string
  popupYn: string
  useYn: string
  useYnNm: string
  delYn: string
  delYnNm: string
}

const ComPrmt: React.FC = () => {
  const axios = useAxios();
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState<DataRow[]>([]);

  const { getComCodes, getComCodeValue } = useRedis();

  const {insertLog} = useLog();
  const today = new Date();
  const before1Month = new Date();
  before1Month.setMonth(today.getMonth() - 1);
  const [searchData, setSearchData] = useState<DataRow>(
    location.state?.searchData || {
      cmpnyCd: '',
      nttSn: '',
      regId: '',
      regDate: '',
      updId: '',
      updDate: '',
      cstId: '',
      bbsSj: '',
      prmtType: '',
      prmtTypeNm: '',
      nttSj: '',
      nttCn: '',
      prmtStartDate: '',
      prmtEndDate: '',
      prmtUrl: '',
      thumbnailSeq: '',
      readngCnt: '',
      adminDelYn: '',
      adminDelYnNm: '',
      tpPrmtYn: '',
      popupYn: '',
      useYn: '',
      useYnNm: '',
      delYn: '',
      delYnNm: '',
    },
  )

  const columns: TableColumn<DataRow>[] = [
    {
      name: '이벤트번호',
      selector: (row) => row.nttSn,
      sortable: true,
      wrap: true,
      width: '8%',
      cell: (row) => (
        <div style={{ width: '100%', textAlign: 'right' }}>{row.nttSn}</div>
      ),
    },
    {
      name: '이벤트제목',
      selector: (row) => row.nttSj,
      sortable: true,
      center: true,
      wrap: true,
      width: '30%',
    },
    {
      name: '이벤트시작일',
      selector: (row) => commonUtils.dateStrChgFomat(row.prmtStartDate, 'yyyy.MM.dd'),
      sortable: true,
      center: true,
      wrap: true,
      width: '8%',
    },
    {
      name: '이벤트종료일',
      selector: (row) => commonUtils.dateStrChgFomat(row.prmtEndDate, 'yyyy.MM.dd'),
      sortable: true,
      center: true,
      wrap: true,
      width: '8%',
    },
    {
      name: '조회수',
      selector: (row) => row.readngCnt.toLocaleString(),
      sortable: true,
      center: true,
      wrap: true,
      width: '8%',
    },
    {
      name: '사용여부',
      selector: (row) => row.useYnNm || row.useYn,
      sortable: true,
      center: true,
      wrap: true,
      width: '6%',
    },
    {
      name: '삭제여부',
      selector: (row) => row.delYnNm || row.delYn,
      sortable: true,
      center: true,
      wrap: true,
      width: '6%',
    },
    {
      name: '관리자삭제여부',
      selector: (row) => row.adminDelYnNm || row.adminDelYn,
      sortable: true,
      center: true,
      wrap: true,
      width: '6%',
    },
    {
      name: '수정자',
      selector: (row) => row.updId,
      sortable: true,
      center: true,
      wrap: true,
      width: '8%',
    },
    {
      name: '수정일시',
      selector: (row) => commonUtils.formatDate(row.updDate, false),
      sortable: true,
      center: true,
      wrap: true,
      width: '8%',
    },
    {
      name: '',
      cell: (row) => (
        <>
          <Button
            variant="outlined"
            color="neverbe"
            size="xs"
            onClick={() => handleButtonUpdateClick(row.nttSn)}
          >
            상세
          </Button>
        </>
      ),
      sortable: false,
      width: '10%',
    },
  ]

  const handleButtonUpdateClick = async (nttSn: string) => {
    navigate(`/prmt/detail`, {
      state: {
        nttSn: nttSn,
        searchData: searchData,
      },
    })
  }

  const getComPrmtList = async () => {
    try {
      // if(commonUtils.isYYYYMMDD(searchData.prmtStartDate)){
      //   setSearchData({
      //     ...searchData,
      //     // prmtStartDate: searchData.prmtStartDate.replaceAll('-', '')+'000000'
      //   })
      // }
      // if(commonUtils.isYYYYMMDD(searchData.prmtEndDate)){
      //   setSearchData({
      //     ...searchData,
      //     // prmtEndDate: searchData.prmtEndDate.replaceAll('-', '')+'235959'
      //   })
      // }

      const response = await axios.post('/prmt/list', {...searchData,
        prmtStartDate : commonUtils.isYYYYMMDD(searchData.prmtStartDate) ? searchData.prmtStartDate.replaceAll('-', '')+'000000' : searchData.prmtStartDate,
        prmtEndDate : commonUtils.isYYYYMMDD(searchData.prmtEndDate) ? searchData.prmtEndDate.replaceAll('-', '')+'235959' : searchData.prmtEndDate
      });

      const listData:DataRow[] = response.data.data.list;
      if (Array.isArray(listData)) {
        for(const data of listData){
          data.useYnNm = getComCodeValue('USE_YN', data.useYn)?.codeNm || '';
          data.delYnNm = getComCodeValue('DEL_YN', data.delYn)?.codeNm || '';
          data.adminDelYnNm = getComCodeValue('DEL_YN', data.adminDelYn)?.codeNm || '';
          data.prmtTypeNm = getComCodeValue('PRMT_TYPE', data.prmtType)?.codeNm || '';
        }
        setData(listData);
      }
    } catch (error:any) {
      insertLog({
        logMsg: error.message,
        stackTrace: error.stack,
        remarks : 'call api /log/list',
      });
    }
  }

  const handleInputChange = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target
    setSearchData((prevState) => {
      return {
        ...prevState,
        [name]: value,
      } as DataRow // 모든 필드를 포함하는 상태를 유지
    })
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  }

  const handleSearch = () => {
    getComPrmtList();
  };


  useEffect(() => {
    getComPrmtList();
  }, [])

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          marginBottom: '10px',
          alignItems: 'center',
          marginTop: '50px',
        }}
      >
        <p style={{ marginLeft: '20px', fontSize: '20px' }}>이벤트관리</p>
        <div style={{ marginLeft: 'auto' }}>
          <div style={{ display: 'flex', gap: '5px' }}>
            <FormGroup>
              <Label htmlFor={'prmtStartDate'}>조회시작일</Label>
              <FlexWrapper>
                <Input
                  placeholder="YYYYMMDD"
                  id="prmtStartDate"
                  name="prmtStartDate"
                  type='date'
                  value={searchData.prmtStartDate}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                />
              </FlexWrapper>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'prmtEndDate'}>조회종료일</Label>
              <FlexWrapper>
                <Input
                  placeholder="YYYYMMDD"
                  id="prmtEndDate"
                  name="prmtEndDate"
                  type='date'
                  value={searchData.prmtEndDate}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                />
              </FlexWrapper>
            </FormGroup>

            <FormGroup>
              <Label htmlFor={'prmtType'}>이벤트구분</Label>
              <Select
                id="prmtType"
                name="prmtType"
                width="120px"
                onChange={handleInputChange}
                value={searchData.prmtType}
              >
                <option value="">전체</option>
                {getComCodes('PRMT_TYPE').map((item) => (
                  <option key={'prmtType'+item.code} value={item.code}>
                      {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'useYn'}>사용여부</Label>
              <Select
                id="useYn"
                name="useYn"
                width="120px"
                onChange={handleInputChange}
                value={searchData.useYn}
              >
                <option value="">전체</option>
                {getComCodes('USE_YN').map((item) => (
                  <option key={'useYn'+item.code} value={item.code}>
                      {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>

            <FormGroup>
              <Label htmlFor={'delYn'}>삭제여부</Label>
              <Select
                id="delYn"
                name="delYn"
                width="100px"
                onChange={handleInputChange}
                value={searchData.delYn}
              >
                <option value="">전체</option>
                {getComCodes('DEL_YN').map((item) => (
                  <option key={'delYn'+item.code} value={item.code}>
                      {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'adminDelYn'}>관리자삭제여부</Label>
              <Select
                id="adminDelYn"
                name="adminDelYn"
                width="120px"
                onChange={handleInputChange}
                value={searchData.adminDelYn}
              >
                <option value="">전체</option>
                {getComCodes('DEL_YN').map((item) => (
                  <option key={'adminDelYn'+item.code} value={item.code}>
                      {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'nttSj'}>
                <></>
              </Label>
              <FlexWrapper>
                <Input
                  placeholder="이벤트제목"
                  width="300px"
                  id="nttSj"
                  name="nttSj"
                  maxLength={100}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                />
              </FlexWrapper>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={''}>
                <></>
              </Label>
              <FlexWrapper gap="10px">
                <Button
                  onClick={handleSearch}
                  color="neverbe"
                  variant="outlined"
                >
                  검색
                </Button>
              </FlexWrapper>
            </FormGroup>
          </div>
        </div>
      </div>
      <DataTable
        columns={columns}                                     // 컬럼정보(header)
        data={data}                                           // 화면에 표시될 데이터
        pagination={true}                                     // 페이징 여부
        paginationRowsPerPageOptions={[10, 20, 30, 50]}       // 한화면에 보여줄 데이터 셀렉트박스
        sortIcon={<></>}                                      // 정렬아이콘 공백처리
        noDataComponent={<>조회결과가 없습니다.</>}
      />
    </>
  )
}
export default ComPrmt
